export { default as RangeControl } from './RangeControl';



// WEBPACK FOOTER //
// ./src/components/FormControls/RangeControl/index.ts